'use strict';

import React, {Component}  from 'react';
import {
  // Icon,
  Modal,
}                          from 'semantic-ui-react';
import PropTypes           from 'prop-types';
import _                   from 'lodash';
import classnames          from 'classnames';
// Styles
import                    './SgrModal.scss';

const propTypes = {
  className : PropTypes.string,
  closeIcon : PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
    PropTypes.string,
  ]),
  content: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string,
  ]),
  defaultOpen : PropTypes.bool,
  header      : PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string,
  ]),
  onClose : PropTypes.func,
  onOpen  : PropTypes.func,
  trigger : PropTypes.element,
};

const defaultProps = {
  className   : void 0,
  closeIcon   : void 0,
  content     : void 0,
  defaultOpen : void 0,
  header      : void 0,
  onClose     : _.noop,
  onOpen      : _.noop,
  trigger     : null,
};

class SgrModal extends Component {

  constructor(props) {
    super(props);

    this.state = {isOpen: false};

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  open(){
    this.handleOpenModal();
  }

  close(){
    this.handleCloseModal();
  }

  handleOpenModal() {
    this.setState({isOpen: true}, () => {
      this.props.onOpen();
    });
  }

  handleCloseModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.props.onClose();
    this.setState({isOpen: false});
  }

  renderContentModal() {
    const {
      content,
      header,
    } = this.props;

    return (
      <React.Fragment>
        {
          header &&
          <Modal.Header>
            {header}
          </Modal.Header>
        }

        <Modal.Content
          image
          scrolling
        >
          <Modal.Description>
            {content}
          </Modal.Description>
        </Modal.Content>
      </React.Fragment>
    );
  }

  render() {
    const {
      className,
      closeIcon,
      defaultOpen,
      trigger,
    } = this.props;

    const {isOpen} = this.state;

    return (
      <Modal
        className={classnames({
          'ready': isOpen,
          className,
        })}
        closeIcon={closeIcon}
        closeOnDimmerClick={false}
        closeOnRootNodeClick={false}
        defaultOpen={defaultOpen}
        onClose={this.handleCloseModal}
        onOpen={this.handleOpenModal}
        open={isOpen}
        size='tiny'
        style={{marginTop: 0}}
        trigger={trigger}
      >
        {this.renderContentModal()}
      </Modal>
    );
  }

}

SgrModal.propTypes = propTypes;
SgrModal.defaultProps = defaultProps;

export default SgrModal;



// WEBPACK FOOTER //
// ./src/molecules/SgrModal/SgrModal.js